var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllocateLicense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33337H2V12.6667H10.5714H14V5.08337V3.33337H9.33333",
    className: "iconStroke",
    strokeWidth: 1.33
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66667,
    y: 6.66663,
    width: 2.66667,
    height: 2.66667,
    className: "iconStroke"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.66666,
    y: 0.999959,
    width: 0.666667,
    height: 3.33333,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.66666,
    y: 6.33333,
    width: 2,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.66666,
    y: 8.99996,
    width: 1.33333,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocateLicense);
export default __webpack_public_path__ + "static/media/allocate_license.b3522b927766815b1af7ad6dc6ba4954.svg";
export { ForwardRef as ReactComponent };